import {Sprite} from '@pixi/react';
import {Assets} from 'pixi.js';
import {Scene} from './Scene';
import {OVERLAY, PLAY_BACKGROUND} from '../assetManifest';
import {BankObjectiveSoundEffect} from '../pixijs/BankObjectiveSoundEffect';
import {ObjectivePanel} from '../pixijs/ObjectivePanel';
import {RemoteCellLayout} from '../pixijs/RemoteCellLayout';
import {RopeCoil} from '../pixijs/RopeCoil';
import {TimePanel} from '../pixijs/TimePanel';

export function Play() {

    return (
        <Scene>
            <Sprite texture={Assets.get(PLAY_BACKGROUND)}/>
            <RemoteCellLayout />
            <RopeCoil/>
            <Sprite texture={Assets.get(OVERLAY)} eventMode={'none'}/>
            <ObjectivePanel />
            <TimePanel/>
            <BankObjectiveSoundEffect />
        </Scene>
    );
}
